<template>
  <div id="Footer" class="footer">
    <div class="footer-top"></div>
    <div class="footer-bottom">
      <div class="footer-left">
        <div class="bottom-1">
          <img src="@/assets/img/服务小程序.png" alt="反馈小程序" />
          <p>供热反馈小程序</p>
        </div>
        <div class="bottom-2">
          <img src="@/assets/img/民信服务号.png" alt="服务号" />
          <p>民信热力服务号</p>
        </div>
      </div>
      <div class="footer-right">
        <div class="footer-right-1">
          <el-row class="rows">
            <el-col v-for="(parent, index) in parentTitles" :key="index" class="rows-col" :span="3.5">
              <router-link :to="parent.path" class="router1">
                <h4 @click="updateHeader(index + 1)">{{ parent.title }}</h4>
                <i class="underline"></i>
              </router-link>
              <div style="margin-top: 15px"></div>
              <div v-if="parent.children && parent.children.length > 0">
                <div style="margin-top: 20px" v-for="(child, subIndex) in parent.children" :key="subIndex">
                  <router-link :to="child.path" class="router2">
                    <h5 style="line-height: 15px" @click="updateHeader(index + 1)">
                      {{ child.title }}
                    </h5>
                  </router-link>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="footer-right-3">
          <p class="title-name">
            <span>{{ this.company_name }}</span>
          </p>
          <p class="address_tel_fax">
            <span>电话：{{ this.company_tel }}</span>
          </p>

          <p class="email_wx">
            <span>邮箱：{{ this.company_email }}</span>
          </p>
          <p class="address_tel_fax">
            <span>地址：{{ this.company_addr }}</span>
          </p>
          <p class="beian">
            <img src="@/assets/img/备案图标.png" alt="备案图标" />
            <a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer\" target="_blank\">{{ this.company_beianhao }}</a>
          </p>
          <p class="beian-num">
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=62090202000585\">{{ this.company_wanganhao }}</a>
          </p>
          <p class="beian">
            <img src="@/assets/img/备案图标.png" alt="备案图标" />
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=62090002000151" rel="noreferrer" target="_blank">甘公网安备62090002000151号</a>
          </p>
          <p class="copy">Copyright &copy; 2022 - {{ new Date().getFullYear() }} 酒泉民信热力发展有限公司</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'Footer',
  async beforeMount() {
    await this.loadData()
  },
  data() {
    return {
      company_name: '',
      company_addr: '',
      company_tel: '',
      company_beianhao: '',
      company_wanganhao: '',
      company_email: '',
      parentTitles: [
        {
          title: '关于民信',
          path: '/about',
          children: [
            {
              title: '企业概况',
              path: '/about'
            },
            {
              title: '企业荣誉',
              path: '/about'
            },
            {
              title: '企业文化',
              path: '/about'
            },
            {
              title: '组织架构',
              path: '/about'
            },
            {
              title: '企业大事记',
              path: '/about'
            },
            {
              title: '热力风采',
              path: '/about'
            }
          ]
        },
        {
          title: '党建工作',
          path: '/party',
          children: [
            {
              title: '党建动态',
              path: '/party'
            },
            {
              title: '党务工作',
              path: '/party'
            },
            {
              title: '党风廉政建设',
              path: '/party'
            }
          ]
        },
        {
          title: '新闻中心',
          path: '/news',
          children: [
            {
              title: '企业新闻',
              path: '/news'
            },
            {
              title: '通知公告',
              path: '/news'
            },
            {
              title: '媒体报道',
              path: '/news'
            },
            {
              title: '行业新闻',
              path: '/news'
            }
          ]
        },
        {
          title: '项目中心',
          path: '/project',
          children: [
            {
              title: '换热站建设',
              path: '/project'
            },
            {
              title: '热力管网建设',
              path: '/project'
            },
            {
              title: '老旧管网改造',
              path: '/project'
            }
          ]
        },
        {
          title: '安全生产',
          path: '/production',
          children: [
            {
              title: '安全文化',
              path: '/production'
            },
            {
              title: '安全生产',
              path: '/production'
            },
            {
              title: '安全宣讲',
              path: '/production'
            }
          ]
        },
        {
          title: '用户服务',
          path: '/service',
          children: [
            {
              title: '服务理念',
              path: '/service'
            },
            {
              title: '收费政策',
              path: '/service'
            },
            {
              title: '缴费流程',
              path: '/service'
            },
            {
              title: '供停暖流程',
              path: '/service'
            },
            // {
            //   title: "供热范围",
            //   path: "/service"
            // },
            {
              title: '服务网点',
              path: '/service'
            },
            {
              title: '供热常识',
              path: '/service'
            }
          ]
        },
        {
          title: '我要反馈',
          path: '/feedback',
          children: [
            {
              title: '我要反馈',
              path: '/feedback'
            }
          ]
        },
        {
          title: '联系我们',
          path: '/contactus',
          children: [
            {
              title: '招贤纳士',
              path: '/contactus'
            }
          ]
        }
      ]
    }
  },
  methods: {
    async loadData() {
      this.loading = true
      if (sessionStorage.getItem('footerBasicdataRequested')) {
        // 如果数据已经请求过，则不再请求
        this.company_name = JSON.parse(sessionStorage.getItem('footerbasicdata1'))
        this.company_addr = JSON.parse(sessionStorage.getItem('footerbasicdata2'))
        this.company_tel = JSON.parse(sessionStorage.getItem('footerbasicdata3'))
        this.company_beianhao = JSON.parse(sessionStorage.getItem('footerbasicdata4'))
        this.company_wanganhao = JSON.parse(sessionStorage.getItem('footerbasicdata5'))
        this.company_email = JSON.parse(sessionStorage.getItem('footerbasicdata6'))
      } else {
        axios
          .all([await this.$http.post('/web/companyBottomInfo/getList')])

          .then(
            axios.spread(res => {
              this.company_name = res.data.data.list[0].company_name
              this.company_addr = res.data.data.list[0].company_addr
              this.company_tel = res.data.data.list[0].company_phone
              this.company_wanganhao = res.data.data.list[0].company_copyright
              this.company_beianhao = res.data.data.list[0].company_beian_number
              this.company_email = res.data.data.list[0].company_email

              sessionStorage.setItem('footerbasicdata1', JSON.stringify(this.company_name))
              sessionStorage.setItem('footerbasicdata2', JSON.stringify(this.company_addr))
              sessionStorage.setItem('footerbasicdata3', JSON.stringify(this.company_tel))
              sessionStorage.setItem('footerbasicdata4', JSON.stringify(this.company_beianhao))
              sessionStorage.setItem('footerbasicdata5', JSON.stringify(this.company_wanganhao))

              sessionStorage.setItem('footerbasicdata6', JSON.stringify(this.company_email))
              sessionStorage.setItem('footerBasicdataRequested', 'true')
            })
          )

          .catch(e => {
            this.$message({
              message: '网络或程序异常！' + e,
              type: 'error'
            })
          })
      }
    },
    updateHeader(content) {
      this.$store.commit('updateHeaderContent', content)
      this.$store.commit('updateHeaderContent1', content)
    }
  }
}
</script>
<style scoped>
.footer {
  width: 100%;
  height: 89vh;
  background-image: url('../assets/img/fc33.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}

.bottom-1 {
  width: 50%;
  height: 100%;
  float: left;
  margin-top: 90px;
  padding-left: 30%;
}

.bottom-1 p {
  font-size: 16px;
}

.bottom-2 {
  width: 50%;
  height: 100%;
  float: right;
  margin-top: 90px;
  padding-left: 15%;
}

.bottom-2 p {
  font-size: 16px;
}

.footer-right-1 {
  width: 60%;
  height: 100%;
  display: inline-block;
}

.rows {
  margin-top: 80px;
  width: 100%;
  padding-left: 0px;
}

.rows-col {
  padding-left: 20px;
}

.footer-right-3 {
  width: 40%;
  float: right;
  height: 100%;
  text-align: left;
}

.footer-top {
  width: 100%;
  height: 50%;
  background-image: url('../assets/img/footerimg.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.bottom-1 p {
  text-align: center;
  width: 120px;
}

.bottom-2 p {
  text-align: center;
  width: 120px;
}

.bottom-1 img {
  width: 120px;
  height: 120px;
}

.bottom-2 img {
  width: 120px;
  height: 120px;
}

.footer-bottom {
  height: 50%;
  width: 100%;
}

.footer-left {
  width: 25%;
  height: 100%;
  float: left;
}

router-link {
  text-decoration: none;
}

.footer-right {
  padding-left: 20px;
  width: 75%;
  height: 100%;
  float: right;
}

.underline {
  opacity: 1;
  width: 30%;
  left: 35%;
  position: relative;
}

i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 1;
  transition: all 0.5s ease;
  background-color: #f18800;
}

.footer-right a {
  color: #000;
  text-decoration: none;
}

.footer-right h4:hover {
  color: #f18800;
}

.footer-right h5:hover {
  color: #f18800;
}

.footer-right h4 {
  color: #000;
  font-size: 18px;
  font-weight: bold;
}

.footer-right h5 {
  color: #000;
  font-size: 16px;
}

.title-name {
  color: black;
  font-size: 18px;
  text-align: left;
  padding-left: 30px;
  margin-top: 88px;
}

.address_tel_fax {
  color: black;
  font-size: 16px;
  margin: 10px 0;
  text-align: left;
  padding-left: 30px;
}

.email_wx {
  color: black;
  font-size: 16px;
  text-align: left;
  padding-left: 30px;
}

.beian img {
  color: black;
  font-size: 12px;
  height: 17.28px;
  width: 16px;
  display: inline-block;
  margin-bottom: 2px;
  margin-left: 30px;
}

.beian a {
  color: black;
  font-size: 16px;
  height: 10px;
  width: 10px;
  text-align: left;
}

.beian {
  color: black;
  font-size: 16px;
  text-align: left;
  height: 25px;
}

.beian-num {
  text-align: left;
  margin-left: 30px;
  font-size: 16px;
}

.copy {
  color: black;
  font-size: 16px;
  margin: 10px 0 10px;
  text-align: left;
  padding-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue